import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { Typography, Icon } from '@americanexpress/aqx-components';
import { StrikethroughOffer } from 'src/universal/components/Strikethrough';
import { SectionTitle } from '../SectionTitle';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';

import { getisTier2Offer, getOfferContent } from 'page_modules/business-pdp/redux';
import { getLtoOfferBadgeText } from 'page_modules/business-pdp/redux';
import { getOfferStylingDtm } from 'src/universal/utils/offerStyling';

import styles from './index.scss?modules';

const DualOfferSeparator = () => (
  <div className={styles.slantedSeparatorContainer}>
    <div className={styles.slantedSeparator} />
    <Icon
      className={styles.slantedSeparatorIcon}
      directory="dls"
      imageName="dls-icon-plus-filled"
    />
  </div>
);

const OfferBox = ({
  offerContent,
  isTier2Offer,
  offerStylingBadgeDtm,
  ltoOfferBadgeText
}) => {
  const {
    offerBoxSectionHeader,
    offerHeader,
    offerDescription,
    dualOfferHeader,
    dualOfferDescription
  } = offerContent;
  if (!offerHeader) return null;
  const renderBadge = isTier2Offer;
  const isDualOffer = !!dualOfferHeader;

  const lazyLoadCallback = () => {
    sendDTMCustomEvent(offerStylingBadgeDtm);
  };

  return (
    <div className={styles.container}>
      <SectionTitle text={offerBoxSectionHeader} />
      <div
        className={clsx(styles.offerBoxContainer, {
          [styles.isTier2]: isTier2Offer,
          [styles.isDualOffer]: isDualOffer
        })}
      >
        {renderBadge && (
          <>
            <LazyScrollMetricTracker
              callBackFunction={lazyLoadCallback}
              startTrackingAfterPznArrival={true}
            />
            <div className={styles.offerBadgeText}>{ltoOfferBadgeText}</div>
          </>
        )}
        <div className={styles.topOffer}>
          <StrikethroughOffer
            className={styles.header}
            header={offerHeader}
            Component="h2"
          />
          <Typography className={styles.description} Component="p">
            {offerDescription}
          </Typography>
        </div>
        {isDualOffer && <DualOfferSeparator />}
        {isDualOffer && (
          <div className={styles.bottomOffer}>
            <StrikethroughOffer
              className={styles.header}
              header={dualOfferHeader}
              Component="h2"
            />
            <Typography className={styles.description} Component="p">
              {dualOfferDescription}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  offerContent: getOfferContent(state),
  isTier2Offer: getisTier2Offer(state),
  offerStylingBadgeDtm: getOfferStylingDtm(state, ownProps.shortName),
  ltoOfferBadgeText: getLtoOfferBadgeText(state, ownProps.shortName)
});

export default connect(mapStateToProps)(OfferBox);
